import React from 'react';
import '../../../App.css';
import withStyles from "@material-ui/core/styles/withStyles";
import MaterialTable from 'material-table';
import { get as getLaunchers } from "../network/Resources";
import { create, update, get, delet } from "../network/PO";
import { getAllowedLicenseCount, getUsedLicenseCount } from "../network/Authwalls";
import { routePermissions } from "../../auth/network/Login";
import { withCookies } from "react-cookie";
import { Message, Grid } from 'shineout'

const service = 'pos';
const path = '';
const styles = theme => ({
    theme: theme,
    root: {
        display: 'wrap',
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
    },
    fab: {
        margin: theme.spacing(1),
    },
    box: {
        component: 'div',
        display: 'inline',
        flexWrap: 'wrap',
    },
    card: {
        padding: theme.spacing(1),
        margin: theme.spacing(2),
    },
    textField: {
        margin: 8,
        padding: theme.spacing(1),
        width: 200,
    },
    media: {
        paddingTop: '56.25%',
    }
});

class POList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                { title: 'PO', field: 'po' },
                { title: 'Vendor', field: 'vendor' },
                { title: 'PO Type', field: 'attribute' },
                // { title: 'Active', field: 'count', editable: 'false' },
                { title: 'Quantity', field: 'quantity' },
                { title: 'Date', field: 'date', type: 'date' },
            ],
            data: [],
            total_count: 0,
            used_count: 0,
            policy: JSON.parse(this.props.cookies.cookies.policy),
            isLoading: true,
            POST: false,
            GET: false,
            PUT: false,
            DELETE: false,
        };
    }

    componentDidMount() {
        var columns = [];
		getLaunchers({ type: "attribute" }, data => {
			console.log(data);
			var attribute_names = {};
			data.map(e => (attribute_names[e.name] = e.name));
			this.state.columns.map(e => {
				if (e.field === "attribute") {
					e.lookup = attribute_names;
					console.log(attribute_names);
					columns.push(e);
				} else {
					columns.push(e);
				}
                return null;
			});
			console.log(columns);
			this.setState({ columns: columns });
		});
        routePermissions(this.props, { service: service, path: path }, result => {
            if (result === null) {
                this.setState({ isError: true })
            } else {
                result.map(method => {
                    this.setState({ [method.name]: true })
                    this.setState({ [method.name + '_DATA']: method.resources })
                })
                if (this.state.GET) {
                    get({}, (data) => {
                        console.log(data)
                        this.setState({ data: data })
                        this.setState({ isLoading: false })
                    });
                    getAllowedLicenseCount(result => {
                        if (result !== undefined) {
                            this.setState(result)
                        }
                    })
                    getUsedLicenseCount(result => {
                        if (result !== undefined) {
                            this.setState(result)
                        }
                    })
                }
            }
        })
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                
                {/*
                <Grid gutter={2} style={{ marginBottom: 20 }}>
                    <Grid width={0.5}>
                        <h2>TOTAL LICENSES: {this.state.total_count}</h2>
                    </Grid>
                    <Grid width={0.5}>
                        <h2>USED LICENSES: {this.state.used_count}</h2>
                    </Grid>
                </Grid>
                */}

                { this.props.cookies.cookies.policyname === "admin" &&
                    <Grid gutter={2} style={{ marginBottom: 20 }}>
                    <Grid width={0.33}>
                        <h2>TOTAL LICENSES: {this.state.total_count}</h2>
                    </Grid>
                    <Grid width={0.33}>
                        <h2>USED LICENSES: {this.state.used_count}</h2>
                    </Grid>
                    <Grid width={0.33}>
                        <h2>REMAINING LICENSES: {this.state.total_count - this.state.used_count}</h2>
                    </Grid>
                </Grid> }
                <MaterialTable
                    title={'PO-List'}
                    columns={this.state.columns}
                    data={this.state.data}
                    isLoading={this.state.isLoading}
                    options={{
                        loadingType: 'overlay',
                        addRowPosition: 'first',
                        actionsColumnIndex: 100,
                        exportAllData: true,
                        exportButton: true,
                        exportDelimiter: ',',
                        exportFileName: 'PO_List_Analysis',
                        pageSize: [50]
                    }}
                    editable={{
                        onRowAdd: this.state.POST ? (newData) =>
                            new Promise(resolve => {
                                create(newData, result => {
                                    if (result)
                                        get({}, (data) => {
                                            this.setState({ data: data });
                                            Message.success('PO created', 3, { position: 'bottom-right' });
                                            resolve();
                                        });
                                    else {
                                        Message.error('Failed to create PO. Try again', 3, { position: 'bottom-right' });
                                        resolve();
                                    }
                                })
                            }) : undefined,
                        onRowUpdate: this.state.PUT ? (newData, oldData) =>
                            new Promise(resolve => {
                                update(oldData, newData, result => {
                                    if (result)
                                        get({}, (data) => {
                                            this.setState({ data: data });
                                            Message.success('PO updated', 3, { position: 'bottom-right' });
                                            resolve();
                                        });
                                    else {
                                        Message.error('Failed to delete PO. Try again', 3, { position: 'bottom-right' });
                                        resolve();
                                    }
                                })
                            }) : undefined,
                        onRowDelete: this.state.DELETE ? oldData =>
                            new Promise(resolve => {
                                delet(oldData.po, result => {
                                    if (result)
                                        get({}, (data) => {
                                            this.setState({ data: data });
                                            Message.success('PO deleted', 3, { position: 'bottom-right' });
                                            resolve();
                                        });
                                    else {
                                        Message.error('Failed to delete PO. Try again', 3, { position: 'bottom-right' });
                                        resolve();
                                    }
                                })
                            }) : undefined,
                    }}
                />
            </div>
        );
    }
}

export default withStyles(styles)(withCookies(POList));